import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { searchProducts } from '../utils/api';
import ProductGrid from '../components/ProductGrid';
import SectionHeading from '../components/SectionHeading';
import { useCart } from '../context/CartContext';

export default function Search(){
  const { search } = useLocation();
  const { q } = useMemo(()=>Object.fromEntries(new URLSearchParams(search).entries()),[search]);
  const { data } = useQuery({ queryKey:['search', q], queryFn:()=>searchProducts({ q }) });
  const { add } = useCart();
  return (<main className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
    <SectionHeading title={`Search: ${q||''}`} subtitle={`${data?.total||0} results`} />
    <ProductGrid items={data?.items||[]} onAdd={add} />
  </main>);
}
